<template>
  <div class="activity">
    <div class="activity-top">
      <DActivityAvatar :activity="activity" />

      <div class="activity-title">
        <DActivityAuthor :activity="activity" />

        <span>
          started following
          <DUserLinkPopup
            :slug="activity.source.slug"
            :url="activity.source.url"
          >
            <template slot="content">
              <a
                class="resource-link"
                :href="activity.source.url"
                @click.stop
              >
                {{ activity.source.firstname }} {{ activity.source.lastname }}
              </a>
            </template>
          </DUserLinkPopup>

        </span>

        <DActivityTimestamp
          :activity="activity"
          class="visible-until-sm"
        />
      </div>

      <DActivityTimestamp
        :activity="activity"
        class="hidden-until-md"
      />
    </div>
  </div>
</template>

<script>
import activityMixin from '../shared/activity-mixin';
import DUserLinkPopup from '@d-components/d-user-link-popup/d-user-link-popup.vue';

export default {
  components: {
    DUserLinkPopup,
  },
  mixins: [
    activityMixin,
  ],
};
</script>

